<template>
  <NavMenu />
  <router-view />
  <!--登录弹窗-->
  <LoginDialog ref="loginDialogRef"></LoginDialog>
</template>

<script setup lang="ts">
import * as LoginApi from '@/api/login.ts'
import NavMenu from '@/components/NavMenu.vue'
import LoginDialog from '@/components/LoginDialog.vue'
import { useRoute } from 'vue-router'
import { useUserStore } from '@/store/user.js'
import { ElMessage } from 'element-plus'
const userStore = useUserStore()
const route = useRoute()
setTimeout(() => {
  if (route.query.rid && !userStore.token) {
    LoginApi.ca9Login({
      rid: route.query.rid
    }).then(res => {
      console.log(res)
      ElMessage.success('登录成功')
      userStore.setToken(res.data.token)
      let userInfo = {}
      Object.keys(res.data).forEach(key => {
        if (res.data[key]) {
          userInfo[key] = res.data[key]
        }
      })
      userStore.setUserInfo(userInfo)
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    })
  }
}, 200)
</script>

<style lang="scss" scoped></style>
